import { images } from './images';
import type { Performer } from '../types/marketplace';

export const ME_PERFORMER_ID = 'p1';

export const performers: Performer[] = [
  {
    id: 'p1',
    name: 'Ploy Siriwan',
    actType: 'Solo singer',
    members: 1,
    genres: ['Soul', 'R&B', 'Jazz', 'T-Pop'],
    photos: [images.ploy, images.jazzClub],
    keys: [
      { id: 'k1', title: 'Valerie', artist: 'Amy Winehouse', genre: 'Soul', sample: true },
      { id: 'k2', title: 'At Last', artist: 'Etta James', genre: 'Soul', sample: true },
      { id: 'k3', title: 'Kid Mak', artist: 'Palmy', genre: 'T-Pop', sample: true },
      { id: 'k4', title: 'Ain’t Nobody', artist: 'Chaka Khan', genre: 'Funk', sample: false },
      { id: 'k5', title: 'Feeling Good', artist: 'Nina Simone', genre: 'Jazz', sample: false },
    ],
    price: 9000,
    city: 'Ari, Bangkok',
    distanceKm: 9,
    travelRadiusKm: 250,
    travelCostPerKm: 8,
    bio: 'Bangkok soul singer with a jazz-bar heart. I sing in English and Thai — Etta and Amy for the rooftop, Palmy for the dance floor.',
    rating: 4.9,
    reviewCount: 38,
    gigsPlayed: 112,
    verified: true,
    availability: ['Thu', 'Fri', 'Sat', 'Sun'],
    reviews: [
      { author: 'The Velvet Room', text: 'Held a packed room silent for “At Last”. Booking again.', rating: 5 },
      { author: 'Pim & Ben', text: 'Our first dance was perfect, and she switched to Thai songs for my parents.', rating: 5 },
    ],
  },
  {
    id: 'p2',
    name: 'Moonlight Avenue',
    actType: 'Band',
    members: 4,
    genres: ['Indie', 'T-Pop', 'Rock'],
    photos: [images.indieBand, images.festival],
    keys: [
      { id: 'k6', title: 'Puean Len Mai Len Puean', artist: 'Tilly Birds', genre: 'T-Pop', sample: true },
      { id: 'k7', title: 'Mr Brightside', artist: 'The Killers', genre: 'Rock', sample: true },
      { id: 'k8', title: 'Dreams', artist: 'Fleetwood Mac', genre: 'Rock', sample: false },
    ],
    price: 25000,
    city: 'Lat Phrao, Bangkok',
    distanceKm: 12,
    travelRadiusKm: 300,
    travelCostPerKm: 15,
    bio: 'Four-piece indie band playing sing-along Thai and English anthems, plus a few of our own. Festival-tested, wedding-approved.',
    rating: 4.7,
    reviewCount: 22,
    gigsPlayed: 64,
    verified: true,
    availability: ['Fri', 'Sat'],
    reviews: [{ author: 'Riverside Sound Co.', text: 'Brilliant energy — the crowd sang every word.', rating: 5 }],
    responsive: true,
  },
  {
    id: 'p3',
    name: 'Blue Hour Trio',
    actType: 'Band',
    members: 3,
    genres: ['Jazz', 'Soul'],
    photos: [images.jazzTrio, images.jazzClub],
    keys: [
      { id: 'k9', title: 'Autumn Leaves', artist: 'Standard', genre: 'Jazz', sample: true },
      { id: 'k10', title: 'Fly Me to the Moon', artist: 'Frank Sinatra', genre: 'Jazz', sample: true },
      { id: 'k11', title: 'Superstition', artist: 'Stevie Wonder', genre: 'Soul', sample: false },
    ],
    price: 20000,
    city: 'Sathorn, Bangkok',
    distanceKm: 7,
    travelRadiusKm: 150,
    travelCostPerKm: 12,
    bio: 'Piano, upright bass and drums. Smooth standards for dinner, soul grooves when the room warms up.',
    rating: 4.9,
    reviewCount: 41,
    gigsPlayed: 150,
    verified: true,
    availability: ['Wed', 'Thu', 'Fri', 'Sat'],
    reviews: [{ author: 'Siam Partners', text: 'Effortlessly classy. Exactly the atmosphere we wanted.', rating: 5 }],
  },
  {
    id: 'p4',
    name: 'Krit Thanakorn',
    actType: 'Solo singer',
    members: 1,
    genres: ['Acoustic', 'T-Pop', 'Folk'],
    photos: [images.acoustic],
    keys: [
      { id: 'k12', title: 'Ting Wai Klang Tang', artist: 'Potato', genre: 'T-Pop', sample: true },
      { id: 'k13', title: 'Valerie', artist: 'Amy Winehouse', genre: 'Soul', sample: true },
      { id: 'k14', title: 'Yellow', artist: 'Coldplay', genre: 'Pop', sample: false },
    ],
    price: 6000,
    city: 'Bang Na, Bangkok',
    distanceKm: 11,
    travelRadiusKm: 100,
    travelCostPerKm: 8,
    bio: 'Singer-songwriter with a loop pedal and endless patience for requests. Great for terraces, cafés and cocktail hours.',
    rating: 4.6,
    reviewCount: 17,
    gigsPlayed: 48,
    verified: false,
    availability: ['Thu', 'Fri', 'Sat', 'Sun'],
    reviews: [{ author: 'Ari Supper Club', text: 'Lovely voice, read the room perfectly.', rating: 5 }],
    responsive: true,
  },
  {
    id: 'p5',
    name: 'The Velvet Brass',
    actType: 'Band',
    members: 6,
    genres: ['Funk', 'Soul', 'Disco'],
    photos: [images.funkBand, images.barn],
    keys: [
      { id: 'k15', title: 'September', artist: 'Earth, Wind & Fire', genre: 'Funk', sample: true },
      { id: 'k16', title: 'Uptown Funk', artist: 'Mark Ronson', genre: 'Funk', sample: true },
      { id: 'k17', title: 'Valerie', artist: 'Amy Winehouse', genre: 'Soul', sample: true },
    ],
    price: 45000,
    city: 'Ratchada, Bangkok',
    distanceKm: 6,
    travelRadiusKm: 800,
    travelCostPerKm: 20,
    bio: 'Six-piece funk & soul party band with a full horn section. Bangkok’s favourite wedding closers.',
    rating: 5,
    reviewCount: 56,
    gigsPlayed: 210,
    verified: true,
    availability: ['Fri', 'Sat', 'Sun'],
    reviews: [{ author: 'Halcyon Rooftop', text: 'Best band we’ve had on the roof. Period.', rating: 5 }],
  },
  {
    id: 'p6',
    name: 'Fah & Mook',
    actType: 'Duo',
    members: 2,
    genres: ['Pop', 'T-Pop', 'Acoustic', 'Soul'],
    photos: [images.popDuo],
    keys: [
      { id: 'k18', title: 'Kid Mak', artist: 'Palmy', genre: 'T-Pop', sample: true },
      { id: 'k19', title: 'Lovely Day', artist: 'Bill Withers', genre: 'Soul', sample: true },
      { id: 'k20', title: 'Dreams', artist: 'The Cranberries', genre: 'Pop', sample: false },
    ],
    price: 12000,
    city: 'On Nut, Bangkok',
    distanceKm: 4,
    travelRadiusKm: 200,
    travelCostPerKm: 10,
    bio: 'Keys and two-part harmonies. Thai and English favourites reworked so they feel brand new.',
    rating: 4.8,
    reviewCount: 29,
    gigsPlayed: 77,
    verified: true,
    availability: ['Thu', 'Fri', 'Sat'],
    reviews: [{ author: 'Coastline Beach Club', text: 'Gorgeous harmonies, total pros.', rating: 5 }],
    responsive: true,
  },
  {
    id: 'p7',
    name: 'Tee Wongsakul',
    actType: 'Solo singer',
    members: 1,
    genres: ['R&B', 'Soul', 'Pop'],
    photos: [images.rnbSinger],
    keys: [
      { id: 'k21', title: 'Earned It', artist: 'The Weeknd', genre: 'R&B', sample: true },
      { id: 'k22', title: 'Let’s Stay Together', artist: 'Al Green', genre: 'Soul', sample: true },
      { id: 'k23', title: 'Adorn', artist: 'Miguel', genre: 'R&B', sample: false },
    ],
    price: 10000,
    city: 'Rama 9, Bangkok',
    distanceKm: 5,
    travelRadiusKm: 120,
    travelCostPerKm: 8,
    bio: 'R&B vocalist with falsetto for days. Smooth sets for late nights and stylish parties.',
    rating: 4.7,
    reviewCount: 19,
    gigsPlayed: 53,
    verified: true,
    availability: ['Fri', 'Sat'],
    reviews: [{ author: 'Sukhumvit Social', text: 'Silky voice and super professional.', rating: 5 }],
  },
  {
    id: 'p8',
    name: 'Baan Rim Nam',
    actType: 'Duo',
    members: 2,
    genres: ['Folk', 'Luk Thung', 'Acoustic'],
    photos: [images.folkDuo, images.beach],
    keys: [
      { id: 'k24', title: 'Kon Ban Diao', artist: 'Phai Phongsathon', genre: 'Luk Thung', sample: true },
      { id: 'k25', title: 'Ho Hey', artist: 'The Lumineers', genre: 'Folk', sample: false },
    ],
    price: 8000,
    city: 'Nonthaburi',
    distanceKm: 22,
    travelRadiusKm: 400,
    travelCostPerKm: 9,
    bio: 'Phin and guitar folk duo. Isan grooves meet campfire folk — perfect for gardens, resorts and family parties.',
    rating: 4.8,
    reviewCount: 24,
    gigsPlayed: 70,
    verified: false,
    availability: ['Sat', 'Sun'],
    reviews: [{ author: 'Halcyon Rooftop', text: 'Made our season finale feel like a festival.', rating: 5 }],
  },
];
